import React from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line import/prefer-default-export
export const dropdownHeaderLabel = (
    <FormattedMessage id="ColoredStatusColumn.dropdownHeaderLabel" defaultMessage="Change Status" />
);
